'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroLoading = require('./NitroLoading');

var _NitroLoading2 = _interopRequireDefault(_NitroLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroLoading2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-loading/index.js
// module id = 18
// module chunks = 4